import { bootToolPage } from '../lib/boot-tool'
import { t } from '../i18n/dictionaries'

const locale = bootToolPage('inspect')

let step = 0
const states = ['todo', 'todo', 'todo', 'todo']

function statusLabel(state: string): string {
  if (state === 'pass') return t(locale, 'status_pass')
  if (state === 'fail') return t(locale, 'status_fail')
  return t(locale, 'status_todo')
}

function paint(): void {
  states.forEach((state, index) => {
    const node = document.querySelector(`[data-step="${index}"]`)
    if (node) {
      node.textContent = statusLabel(state)
      node.closest('li')?.classList.toggle('is-current', index === step)
      node.closest('li')?.setAttribute('data-state', state)
    }
  })
  const completed = states.filter((state) => state !== 'todo').length
  const count = document.querySelector('[data-wizard-count]')
  const progress = document.querySelector<HTMLElement>('[data-wizard-progress]')
  if (count) count.textContent = `${completed} / ${states.length}`
  if (progress) progress.style.width = `${(completed / states.length) * 100}%`
}

document.querySelector('[data-action="pass"]')?.addEventListener('click', () => {
  states[step] = 'pass'
  step = Math.min(step + 1, states.length - 1)
  paint()
  localStorage.setItem('sd.wizard', JSON.stringify(states))
})

document.querySelector('[data-action="fail"]')?.addEventListener('click', () => {
  states[step] = 'fail'
  step = Math.min(step + 1, states.length - 1)
  paint()
  localStorage.setItem('sd.wizard', JSON.stringify(states))
})

try {
  const saved = JSON.parse(localStorage.getItem('sd.wizard') || 'null')
  if (Array.isArray(saved)) {
    saved.forEach((value, index) => {
      if (typeof value === 'string') states[index] = value
    })
    const firstTodo = states.findIndex((state) => state === 'todo')
    step = firstTodo === -1 ? states.length - 1 : firstTodo
  }
} catch {
  // ignore bad local drafts
}
paint()
